import React from "react";
import { matchPath } from "react-router-dom";

import SidebarNavListItem from "./SidebarNavListItem";
import SidebarNavList from "./SidebarNavList";

import { useAuth } from "@auth/AuthContext";

const reduceChildRoutes = (props) => {
  const { items, page, depth, currentRoute } = props;
  const { permissions } = useAuth();

  // LWI-661 — explicit mode for the permission gate. Defaults to 'any'
  // (existing behavior). Items can opt into 'all' when a sidebar entry
  // requires every listed permission to be useful (e.g., a page that
  // both lists and edits requires both perms to be worth showing).
  if (Array.isArray(page.permissions) && page.permissions.length > 0) {
    const mode = page.permissionsMode === "all" ? "all" : "any";
    const hasPermission =
      mode === "all"
        ? page.permissions.every((perm) => permissions?.includes(perm))
        : page.permissions.some((perm) => permissions?.includes(perm));
    if (!hasPermission) {
      return items; // 🔒 User missing required permissions, don't render this item
    }
  }

  if (page.children) {
    const open = page.href
      ? !!matchPath({ path: page.href, end: false }, currentRoute)
      : false;

    items.push(
      <SidebarNavListItem
        depth={depth}
        icon={page.icon}
        key={page.title}
        disabled={page.disabled}
        badge={page.badge}
        open={!!open}
        title={page.title}
        href={page.href}
      >
        <SidebarNavList depth={depth + 1} pages={page.children} />
      </SidebarNavListItem>
    );
  } else {
    items.push(
      <SidebarNavListItem
        depth={depth}
        href={page.href}
        icon={page.icon}
        key={page.title}
        disabled={page.disabled}
        badge={page.badge}
        title={page.title}
      />
    );
  }

  return items;
};

export default reduceChildRoutes;
